import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import styled from '@emotion/styled'

import './InputTextArea.scss'

export const INPUT_TEXTAREA_VARIANT_DANGER = 'danger'

const StyledBottomBar = styled.div`
  padding: 12px 8px;
  border-radius: 0 0 4px 4px;
  color: var(--boulder);
  border: 1px solid var(--geyser);
  border-color: ${props =>
    props.variant === INPUT_TEXTAREA_VARIANT_DANGER
      ? 'var(--sunset-orange)'
      : null};
  border-top: 1px solid var(--athensGray);
`
export const InputTextArea = ({
  placeholder,
  className,
  disabled,
  value,
  variant,
  onChange,
  onBlur,
  name,
  id,
  onKeyUp,
  rows,
  children,
  'data-mu-test': dataAttributeTest,
  ...otherProps
}) => {
  const inputName = name && `input-${name}`
  const inputId = id || inputName

  return (
    <span
      className={classnames('e-input-textarea', className, {
        'e-input-textarea--disabled': disabled,
        'e-input-textarea--danger': variant === INPUT_TEXTAREA_VARIANT_DANGER
      })}
    >
      <textarea
        type='text'
        className={classnames('e-input-textarea__input', {
          'e-input-textarea__input--withBottomBar': children
        })}
        disabled={disabled}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onKeyUp={onKeyUp}
        name={inputName}
        id={inputId}
        rows={rows || 3}
        data-mu-test={classnames('input', dataAttributeTest)}
        {...otherProps}
      />
      {children && (
        <StyledBottomBar variant={variant}>{children}</StyledBottomBar>
      )}
    </span>
  )
}

InputTextArea.propTypes = {
  disabled: PropTypes.bool,
  className: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onKeyUp: PropTypes.func,
  variant: PropTypes.oneOf([
    INPUT_TEXTAREA_VARIANT_DANGER,
    '',
    null,
    undefined
  ]),
  children: PropTypes.node,
  /**
   * Additional values for data-attribute used for tests and tracking
   **/
  'data-mu-test': PropTypes.string
}
